import _defineProperty from "/Users/mac/github/elemental-zcash/react/docs/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { CorePalette, colorUtils } from '@elemental-design/material-color-utilities';

var generatePalette = function generatePalette(hex) {
  var _ref;

  var argb = colorUtils.intFromHex(hex);
  var core = CorePalette.of(argb);
  var tone50 = colorUtils.hexFromInt(core.a1.tone(0));
  var tone100 = colorUtils.hexFromInt(core.a1.tone(10));
  var tone200 = colorUtils.hexFromInt(core.a1.tone(20));
  var tone300 = colorUtils.hexFromInt(core.a1.tone(30));
  var tone400 = colorUtils.hexFromInt(core.a1.tone(40));
  var tone500 = colorUtils.hexFromInt(core.a1.tone(50));
  var tone600 = colorUtils.hexFromInt(core.a1.tone(60));
  var tone700 = colorUtils.hexFromInt(core.a1.tone(70));
  var tone800 = colorUtils.hexFromInt(core.a1.tone(80));
  var tone900 = colorUtils.hexFromInt(core.a1.tone(90));
  return _ref = {}, _defineProperty(_ref, 50, tone50), _defineProperty(_ref, 100, tone100), _defineProperty(_ref, 200, tone200), _defineProperty(_ref, 300, tone300), _defineProperty(_ref, 400, tone400), _defineProperty(_ref, 500, tone500), _defineProperty(_ref, 600, tone600), _defineProperty(_ref, 700, tone700), _defineProperty(_ref, 800, tone800), _defineProperty(_ref, 900, tone900), _ref;
};

export { generatePalette };